import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NewSubscriptionStep1Page } from './new-subscription-step1';

@NgModule({
  declarations: [
    NewSubscriptionStep1Page,
  ],
  imports: [
    IonicPageModule.forChild(NewSubscriptionStep1Page),
  ],
  exports: [
    NewSubscriptionStep1Page
  ]
})
export class NewSubscriptionStep1PageModule { }



// WEBPACK FOOTER //
// ./src/pages/new-subscription-step1/new-subscription-step1.module.ts